import {AfterViewInit, Component, Inject, LOCALE_ID, OnDestroy, OnInit, Type, ViewChild, ViewEncapsulation} from '@angular/core';
import {
  ActionDataTable,
  ColumnDataTable,
  DataTableComponent,
  DataTableHeaderComponentService, HeaderComponent
} from '@Common/widgets/general/data-table';
import {DatePipe} from '@angular/common';
import {SubSink} from '@Common/core/utils/subsink';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {Deposit, DepositState} from '../../common/services/deposit/deposit.model';
import {DepositService} from '../../common/services/deposit/deposit.service';
import {Router} from '@angular/router';
import {LocationService} from 'app/archivage/common/services/deposit/location.service';
import {StoreFilterService} from 'app/archivage/common/services/store/store-filter.service';
import {StoredFilters} from 'app/archivage/common/services/store/store.model';
import {MatDialog} from '@angular/material/dialog';
import {HelperDeposit} from 'app/archivage/common/helper/helperDeposit';
import {
  FilterDirCmpDepositsComponent
} from '../../common/components/deposit-filters/filter-dir-cmp-deposits/filter-dir-cmp-deposits.component';
import {FilterDirCmpDepositsData} from '../../common/components/deposit-filters/filter-dir-cmp-deposits/filter-dir-cmp-deposits.model';
import {FilterStateDepositsComponent} from '../../common/components/deposit-filters/filter-state-deposits/filter-state-deposits.component';
import {FilterStateDepositsData} from '../../common/components/deposit-filters/filter-state-deposits/filter-state-deposits.model';
import {
  FilterConservationDepositsComponent
} from '../../common/components/deposit-filters/filter-conservation-deposits/filter-conservation-deposits.component';
import {
  FilterConservationDepositsData
} from '../../common/components/deposit-filters/filter-conservation-deposits/filter-conservation-deposits.model';
import {FilterBaseDepositsModel} from '../../common/components/deposit-filters/filter-base-deposits.model';
import {
  FilterDemandeurDepositsComponent
} from '../../common/components/deposit-filters/filter-demandeur-deposits/filter-demandeur-deposits.component';
import {
  FilterDemandeurDepositsData
} from '../../common/components/deposit-filters/filter-demandeur-deposits/filter-demandeur-depostifs.model';
import {
  FilterRevisionDepositsComponent
} from '../../common/components/deposit-filters/filter-revision-deposits/filter-revision-deposits.component';
import {FilterRevisionDepositsData} from '../../common/components/deposit-filters/filter-revision-deposits/filter-revision-deposits.model';
import {FilterDateDepositsComponent} from '../../common/components/deposit-filters/filter-date-deposits/filter-date-deposits.component';
import {FilterDateDepositsData} from '../../common/components/deposit-filters/filter-date-deposits/filter-date-depostifs.model';
import * as FileSaver from 'file-saver';
import * as dateFnsAdaptor from 'date-fns';
import {PubSubService} from '@Common/core/services';
import {finalize} from 'rxjs/operators';

/**
 * Constantes pour les filtres : quelle colonne de la datatable et le nom unique du filtre
 */
export const filterDirCmpColumn = 'dir_cmp';
export const filterDirCmpName = 'dir_cmp_filter';

export const filterStateColumn = 'state';
export const filterStateName = 'state_filter';

export const filterConservationColumn = 'conservation';
export const filterConservationName = 'conservation_filter';

export const filterDemandeurColumn = 'user';
export const filterDemandeurName = 'demandeur_filter';

export const filterRevisionMinColumn = 'revision_year_min';
export const filterRevisionMinName = 'revision_min_filter';

export const filterRevisionMaxColumn = 'revision_year_max';
export const filterRevisionMaxName = 'revision_max_filter';

export const filterDateIncomingColumn = 'incoming_date';
export const filterDateIncomingName = 'incoming_date_filter';

/**
 * Liste des versements gestionnaire
 */
@Component({
  selector: 'app-versements',
  templateUrl: './versements.component.html',
  styleUrls: ['./versements.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VersementsComponent implements OnInit, OnDestroy, AfterViewInit {
  dsDeposits: MatDataSourceGeneric<Deposit> = new MatDataSourceGeneric<Deposit>();
  extraParams: Map<string, string> = new Map<string, string>();
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  columns: ColumnDataTable[] = [
    {
      columnDef: 'user', header: 'Demandeur',
      display: (element: Deposit) => `${element.user_obj.first_name} ${element.user_obj.last_name}`,
      tooltip: (element) => `${element.user_obj.first_name} ${element.user_obj.last_name}`,
      headerFilterToolTip: (row) => `Filtrer sur un demandeur`,
      sort: true, sortField: 'user__user__last_name'
    },
    {
      columnDef: filterDirCmpColumn, header: 'Entité',
      display: (element: Deposit) => `${element.dir_cmp_obj?.entite_archivage_obj?.entite_obj?.name ?? ''}`,
      tooltip: (element) => `${element.dir_cmp_obj?.entite_archivage_obj?.entite_obj?.name ?? ''}`,
      headerFilterToolTip: (row) => `Filtrer sur une direction / composante`,
      sort: true
    },
    {
      columnDef: 'dt_created', header: 'Créé le', display: (element: Deposit) => {
        return this._checkDate(element?.dt_created);
      },
      tooltip: (element) => {
        return this._getDate(element?.dt_created);
      },
      flex: 5,
      sort: false
    },
    {
      columnDef: 'dt_updated', header: 'Modifié le', display: (element: Deposit) => {
        return this._checkDate(element?.dt_updated);
      },
      tooltip: (element) => {
        return this._getDate(element?.dt_updated);
      },
      flex: 5,
      sort: false
    },

    {
      columnDef: 'state', header: 'Etat', display: (deposit: Deposit) => this.depositSvc.getChipButton(deposit),
      tooltip: (element) => element.type,
      headerFilterToolTip: (row) => `Filtrer sur état`,
      sort: true
    },

    {
      columnDef: 'conservation', header: 'Sort final',
      display: (element: Deposit) => this.depositSvc.displayConservation(element),
      tooltip: (element) => element.conservation,
      headerFilterToolTip: (row) => `Filtrer sur le sort final`,
      sort: true
    },

    {
      columnDef: 'boxes_number', header: 'Nombre de boites',
      display: (element: Deposit) => element.boxes_number,
      tooltip: (element) => element.boxes_number,
      sort: false
    },

    {
      columnDef: 'revision_year_min', header: 'Année révision min',
      display: (element: Deposit) => element?.revision_year_min,
      tooltip: (element) => element?.revision_year_min,
      headerFilterToolTip: (row) => `Filtrer sur une révision min`,
      sort: false
    },

    {
      columnDef: 'revision_year_max', header: 'Année révision max',
      display: (element: Deposit) => element?.revision_year_max,
      tooltip: (element) => element?.revision_year_max,
      headerFilterToolTip: (row) => `Filtrer sur une révision max`,
      sort: false
    },

    {
      columnDef: 'incoming_date', header: 'Date prise en charge',
      display: (element: Deposit) => this._checkDate(element?.incoming_date),
      tooltip: (element) => this._checkDate(element?.incoming_date),
      headerFilterToolTip: (row) => `Filtrer sur une date`,
      sort: false
    },
    {
      columnDef: 'deposit_identifier', header: 'Numéro de versement',
      display: (deposit: Deposit) => deposit.deposit_identifier,
      sort: false, hidden: false, flex: 10
    },
    {
      columnDef: 'location', header: 'Localisation',
      display: (deposit: Deposit) => this.locationSvc.displayLocation(deposit?.location_obj),
      sort: false, hidden: false
    },
  ];

  actions: ActionDataTable[] = [
    {
      label: 'visualize', tooltip: 'Visualiser cette boîte', icon: 'remove_red_eye',
      click: (row: Deposit) => this._goToVersementConsultation(row),
      iconcolor: 'accent',
    },
    {
      label: 'print_box', tooltip: 'Imprimer les descriptions des boites', icon: 'print',
      click: (deposit: Deposit) => this._printBox(deposit),
      hidden: (deposit: Deposit) => {
        const printEnable: DepositState[] = [DepositState.DONE, DepositState.ARCHIVED];
        return !printEnable.includes(deposit.state);
      },
      iconcolor: 'accent',
    },
    {
      label: 'print_deposit', tooltip: 'Imprimer le dépôt', icon: 'picture_as_pdf',
      click: (deposit: Deposit) => this._printDeposit(deposit),
      hidden: (deposit: Deposit) => {
        const printEnable: DepositState[] = [DepositState.DONE, DepositState.ARCHIVED];
        return !printEnable.includes(deposit.state);
      },
      iconcolor: 'accent',
    },
  ];

  subSink = new SubSink();
  storedFilters: StoredFilters;
  constructor(@Inject(LOCALE_ID) private locale: string,
              public dialog: MatDialog,
              private router: Router,
              private pubSvc: PubSubService,
              private helperDeposit: HelperDeposit,
              private depositSvc: DepositService,
              private locationSvc: LocationService,
              private storeFiltersSvc: StoreFilterService,
              private dtTableHeaderSvc: DataTableHeaderComponentService
              ) {
    this.dsDeposits.daoService = this.depositSvc;
  }

  ngOnInit(): void {
    this._initFilters();
  }
  ngAfterViewInit(): void {
    this.subSink.sink = this.storeFiltersSvc.filters
      .subscribe((filters: StoredFilters) => this._updateFilterAndReload(filters));
  }
  private _updateFilterAndReload(filters: StoredFilters) {
    this._copyDatas(filters);
    this.dataTable.reload();
  }

  private _copyDatas(filters: StoredFilters) {
    this.storedFilters = filters;
    this.extraParams.set('archived', filters.manager_archived.toString());
    this.extraParams.set('draft', filters.manager_user_draft.toString());
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
  private _getDate(date: string) {
    const dp: DatePipe = new DatePipe(this.locale);
    return `${(date ? dp.transform(`${date}`, 'dd/MM/yyyy') : '')}`;
  }
  private _checkDate(date: string) {
    return `<strong>${this._getDate(date)}</strong>`;
  }

  private _goToVersementConsultation(versement: Deposit): void {
    this.router.navigate(['versement/consultation-edit', versement.id]);
  }

  toggleArchived(checked: boolean) {
    this.storedFilters.manager_user_draft = false;
    this.storedFilters.manager_archived = checked;
    this.storeFiltersSvc.update(this.storedFilters);
  }
  toggleDraft(checked: boolean) {
    this.storedFilters.manager_archived = false;
    this.storedFilters.manager_user_draft = checked;
    this.storeFiltersSvc.update(this.storedFilters);
  }

  private _printBox(deposit: Deposit) {
    this.helperDeposit
      .exportBoxPdf(deposit, this.depositSvc, this.dialog);
  }
  private _printDeposit(deposit: Deposit) {
    const formattedDate = dateFnsAdaptor.format(new Date(), 'dd-MM-yyyy-hhmm');
    const _date = (formattedDate.slice(0, 13) + 'h' + formattedDate.slice(13));
    this.pubSvc.publish('loading', true);
    this.subSink.sink = this.depositSvc
      .exportDepositPdf(deposit)
      .pipe(finalize(() => this.pubSvc.publish('loading', false)))
      .subscribe((_data) => FileSaver.saveAs(_data, `${deposit.deposit_identifier}-${_date}.pdf`));
  }
  private dataTableReload() {
    if (this.dataTable) {
      this.dataTable.reload();
    }
  }

  /**
   * Création des différents filtres colonnes
   * @private
   */
  private _initFilters() {
    this._setFilter(this.columns, FilterDirCmpDepositsComponent,
      filterDirCmpColumn, filterDirCmpName, 'dir. / cmp.',
      null,
      this._setExtraParamsDirCmp, this._setRazExtraParams, () => this.dataTableReload());
    this._setFilter(this.columns, FilterStateDepositsComponent,
      filterStateColumn, filterStateName, 'état dépôts',
      null,
      this._setExtraParamsState, this._setRazExtraParams, () => this.dataTableReload());
    this._setFilter(this.columns, FilterConservationDepositsComponent,
      filterConservationColumn, filterConservationName, 'type sort final',
      null,
      this._setExtraParamsConservation, this._setRazExtraParams, () => this.dataTableReload());
    this._setFilter(this.columns, FilterDemandeurDepositsComponent,
      filterDemandeurColumn, filterDemandeurName, 'demandeur',
      null,
      this._setExtraParamsDemandeur, this._setRazExtraParams, () => this.dataTableReload());
    // révisions max / min
    this._setFilter(this.columns, FilterRevisionDepositsComponent,
      filterRevisionMaxColumn, filterRevisionMaxName, 'révision max',
      null,
      this._setExtraParamsRevisionMax, this._setRazExtraParams, () => this.dataTableReload());
    this._setFilter(this.columns, FilterRevisionDepositsComponent,
      filterRevisionMinColumn, filterRevisionMinName, 'révision min',
      null,
      this._setExtraParamsRevisionMin, this._setRazExtraParams, () => this.dataTableReload());
    this._setFilter(this.columns, FilterDateDepositsComponent,
      filterDateIncomingColumn, filterDateIncomingName, 'date prise en charge',
      null,
      this._setExtraParamsDate, this._setRazExtraParams, () => this.dataTableReload());
  }

  /**
   * Callbacks à la validation / réinitialisation des différentes colonnes filtres pour filtrage via l'API (filters backend)
   * @private
   */
  private _setExtraParamsDirCmp(data: FilterDirCmpDepositsData, column, extraParams) {
    extraParams.set(column, data.value.id.toString());
  }
  private _setExtraParamsState(data: FilterStateDepositsData, column, extraParams) {
    extraParams.set(column, data.value.toString());
  }
  private _setExtraParamsConservation(data: FilterConservationDepositsData, column, extraParams) {
    extraParams.set(column, data.value.toString());
  }
  private _setExtraParamsDemandeur(data: FilterDemandeurDepositsData, column, extraParams) {
    extraParams.set(column, data.value.toString());
  }
  private _setExtraParamsRevisionMax(data: FilterRevisionDepositsData, column, extraParams) {
    extraParams.set(column, data.value.toString());
  }
  private _setExtraParamsRevisionMin(data: FilterRevisionDepositsData, column, extraParams) {
    extraParams.set(column, data.value.toString());
  }
  private _setExtraParamsDate(data: FilterDateDepositsData, column, extraParams) {
    const _ddmmyyyy = data.value.split('/');
    const _dateDjango = `${_ddmmyyyy[2]}-${_ddmmyyyy[1]}-${_ddmmyyyy[0]}`;
    extraParams.set(column, _dateDjango);
  }
  private _setRazExtraParams(data, column, extraParams) {
    extraParams.delete(column);
  }

  /**
   * Init d'un filtre colonne
   * @param {ColumnDataTable[]} columns : les colonnes utilisées de la datatable
   * @param {Type<HeaderComponent>} componentFilter : le composant de filtre développé
   * @param {string} columnFilter : la colonne concernée (columnDef)
   * @param {string} filterName : le nom du filtre, unique
   * @param {string} filterTitle : le libellé de la pastille lorsque le filtre est utilisé (haut gauche de la datatable)
   * @param {any} data : passage de données pour l'init du composant filtre le cas échéant
   * @param {Function} callBackValidate : la fonction utilisée lors de l'utilisation du filtre
   * @param {Function} callBackRaz : fonction de réinit
   * @param {Function} callBackAction : fonction à appeler après filtrage ou réinit
   * @private
   */
  private _setFilter(columns: ColumnDataTable[],
                     componentFilter: Type<HeaderComponent>,
                     columnFilter: string,
                     filterName: string, filterTitle: string,
                     data: any,
                     callBackValidate: Function,
                     callBackRaz: Function,
                     callBackAction: Function = null) {
    const filterComponent = this.dtTableHeaderSvc.createHeaderComponent(columns,
      columnFilter, filterName, filterTitle,
      componentFilter, data, true);
    if (filterComponent && filterComponent.subject$) {
      this.subSink.sink = filterComponent.subject$.subscribe((_data: FilterBaseDepositsModel) => {
        if (_data) {
          if (_data.action === 'validate') {
            filterComponent.data = _data.value;
            if (_data.value) {
              callBackValidate.call(null, _data, columnFilter, this.extraParams);
            }
          }
          if (_data.action === 'reinit') {
            filterComponent.data = null;
            callBackRaz.call(null, _data, columnFilter, this.extraParams);
          }
          if (callBackAction) {
            callBackAction.call(null, null);
          }
        }
      });
    }
  }
}
